import { render, staticRenderFns } from "./EvaluationEvaluatorsTable.vue?vue&type=template&id=22b38f9c&scoped=true"
import script from "./EvaluationEvaluatorsTable.vue?vue&type=script&lang=js"
export * from "./EvaluationEvaluatorsTable.vue?vue&type=script&lang=js"
import style0 from "./EvaluationEvaluatorsTable.vue?vue&type=style&index=0&id=22b38f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b38f9c",
  null
  
)

export default component.exports